<template>
  <div class="container">
    <header>
      <div class="header-row">
        <h3 class="app-title">BiZOOPe Portal</h3>
      </div>
    </header>
    <div class="logo">
      <gl-logo-bizoope size="middle"/>
    </div>

    <div class="login-form">
      <!-- マルチテナント版ではどのサイト・企業のユーザーなのかログイン時には
           分からないため、企業コードの選択は削除します。-->
      <!-- <md-field>
        <label>Company</label>
        <md-select v-model="companyCode">
          <md-option v-for="c in companies" :key="c.code" :value="c.code">{{
            c.name
          }}</md-option>
        </md-select>
     </md-field> -->

      <md-field>
        <label>Login ID</label>
        <md-input v-model="loginId" @keyup.enter="login"></md-input>
      </md-field>
      <md-field>
        <label>Password</label>
        <md-input type="password" v-model="password" @keyup.enter="login"></md-input>
      </md-field>
      <p class="actions">
        <md-button class="md-primary" :disabled="loading" v-on:click="login">Login</md-button>
      </p>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      <p class="faq-link"><faq-link path="/tags/ログイン"/></p>
      <p class="service-uptime">{{ serviceUptime }}</p>
    </div>
  </div>
</template>

<script>
function isInvalidCredential(response) {
  if (response.status !== 400) {
    return false
  }
  if (!response.data) {
    return true
  }
  if (!response.data.cause) {
    return true
  }

  return response.data.cause.toUpperCase() === 'INVALIDCREDENTIALS'
}
const LAST_COMPANY_CODE_KEY = 'bizoo.last.companyCode'
const storage = localStorage

import FaqLink from '../components/FaqLink.vue'
import { fetchCurrentStatus } from '../services/serviceStatus'

export default {
  components: {
    FaqLink,
  },
  data() {
    return {
      loginId: '',
      password: '',
      companyCode: 'dummy',
      errorMessage: undefined,
      loading: false,
      companies: [],
    }
  },
  computed: {
    serviceUptime() {
      if (
        this.$store.state.service.timeOpen &&
        this.$store.state.service.timeClose
      ) {
        return `サービス稼働時間 ${this.$store.state.service.timeOpen}～${
          this.$store.state.service.timeClose
        }`
      } else {
        return ''
      }
    },
  },
  methods: {
    async login() {
      this.loading = true

      const loginId = this.loginId
      const password = this.password
      const companyCode = this.companyCode

      if (!loginId || !password || !companyCode) {
        this.loading = false
        return
      }

      try {
        await this.$store.dispatch('login', { companyCode, loginId, password })
      } catch (error) {
        if (isInvalidCredential(error.response)) {
          this.errorMessage = error.response.data.message
          this.password = ''
          this.loading = false
          return
        }
      }
      storage.setItem(LAST_COMPANY_CODE_KEY, companyCode)

      this.loading = false
      this.$router.push(this.$route.query.redirect || '/')
    },
  },
  async created() {
    this.companies = this.$store.state.companies

    try {
      const status = await fetchCurrentStatus()
      this.$store.commit('setServiceStatus', status)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('サービス稼働状況が取得できませんでした。', error)
      return
    }
    // this.companyCode =
    //   storage.getItem(LAST_COMPANY_CODE_KEY) || this.companies[0].code
  },
}
</script>

<style scoped lang="scss">
header {
  background: var(--md-theme-default-primary, #448aff);
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100; // force top

  .app-title {
    cursor: pointer;
  }
}

.header-row {
  align-items: center;
  display: flex;
  height: 56px;
  margin-left: 24px;
  margin-right: 24px;
}

.container {
  height: 100vh;
  width: 100vw;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-form {
  width: 300px;
}

.actions {
  text-align: center;
}

.error-message {
  text-align: center;
  color: #e91e63;
}

.faq-link {
  text-align: center;
}

.service-uptime {
  text-align: center;
}

.logo {
  margin-bottom: 50px;
}
</style>
